import React, { useState } from "react";
import * as XLSX from "xlsx";
import { bulkCreateConsultant } from "../Services/consultantService";
import { handleOutsideClick } from "../../../Helpers/HandleOutsideClick";

const BulkImportModal = ({ show, onClose, setAlert }) => {
  const [uploadedExcelFile, setUploadedExcelFile] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);

  if (!show) return null;

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadedExcelFile(file);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        XLSX.utils.sheet_to_json(ws);

        setAlert({
          type: "Success",
          message: "File selected successfully.",
        });
      } catch {
        setAlert({
          type: "fail",
          message: "Invalid Excel file format.",
        });
        setUploadedExcelFile(null);
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleBulkUpload = async () => {
    if (!uploadedExcelFile) {
      setAlert({
        type: "fail",
        message: "Please select a file first.",
      });
      return;
    }

    try {
      setBulkLoading(true);

      const response = await bulkCreateConsultant(uploadedExcelFile);
      const data = response.data;

      //  Backend message only
      setAlert({
        type: data.status || "Success",
        message: data.message,
      });

      resetAndClose();
    } catch (error) {
      setAlert({
        type: "fail",
        message:
          error?.response?.data?.message ||
          "Bulk upload failed. Please try again.",
      });
    } finally {
      setBulkLoading(false);
    }
  };

  const resetAndClose = () => {
    setUploadedExcelFile(null);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4"
      onClick={(e) => handleOutsideClick(e, onClose)}>
      <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-[#0467c5]">
            Bulk Import Consultants
          </h2>
          <button
            onClick={resetAndClose}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>

        <hr className="mb-4" />

        {/* Sample Download */}
        {!uploadedExcelFile && (
          <div className="flex justify-end mb-3">
            <button
              onClick={() => {
                const link = document.createElement("a");
                link.href = "/SampleBulkImport.xlsx";
                link.download = "SampleBulkImport.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              className="text-sm text-blue-600 hover:underline"
            >
               Download Sample Excel
            </button>
          </div>
        )}

        {/* File Upload */}
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          disabled={bulkLoading}
          className="w-full border border-gray-300 rounded-md p-2 mb-6"
        />

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={resetAndClose}
            className="px-4 py-2 bg-gray-200 rounded-md"
          >
            Close
          </button>

          <button
            onClick={handleBulkUpload}
            disabled={bulkLoading}
            className="px-6 py-2 bg-[#0467c5] text-white rounded-md disabled:opacity-50"
          >
            {bulkLoading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkImportModal;
